export default __webpack_public_path__ + "static/media/7.1db2fab4.png";